import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import "../addrequest/addrequest.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const safeJSON = (str, fallback) => {
    try { return str ? JSON.parse(str) : fallback; } catch { return fallback; }
};

const EditTour = ({ user, API_URL }) => {
    const navigate = useNavigate();
    const { id } = useParams();

    // ─── Статус загрузки заявки ────────────────────────────────────
    const [loading, setLoading] = useState(true);
    const [accessDenied, setAccessDenied] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [order, setOrder] = useState(null);
    const [type, setType] = useState(null);
    const [hydrated, setHydrated] = useState(false);

    // ─── Тип заявки ───────────────────────────────────────────────
    const [typerequest, setTyperequest] = useState(null);
    const isShare = typerequest?.value === "sharetour";

    // ─── Заказчик (только для "partners") ─────────────────────────
    const [comp, setComp] = useState(null);
    const [tourOperator, setTourOperator] = useState("");
    const [customerContacts, setCustomerContacts] = useState("");
    const [groupNumber, setGroupNumber] = useState("");

    // ─── Гости ──────────────────────────────────────────────────────
    const [guests, setGuests] = useState([{ name: "", contacts: "" }]);
    const updateGuest = (index, field, value) => {
        const arr = [...guests];
        arr[index][field] = value;
        setGuests(arr);
    };

    // ─── Программа тура ───────────────────────────────────────────
    const [tour, setTour] = useState(null);
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const [participantsCount, setParticipantsCount] = useState("");
    const [needsYurt, setNeedsYurt] = useState({ value: false, label: "Нет" });
    const [yurtComment, setYurtComment] = useState("");
    // ─── Логистика ──────────────────────────────────────────────────
    const [departurePlace, setDeparturePlace] = useState("");
    const [departureTime, setDepartureTime] = useState("");
    const [arrivalPlace, setArrivalPlace] = useState("");
    const [transportType, setTransportType] = useState("");
    const [guid, setGuid] = useState(null);
    const [guidlang, setGuidlang] = useState("");
    const [museum, setMuseum] = useState("");
    const [extraLocation, setExtraLocation] = useState("");

    // ─── Питание ──────────────────────────────────────────────────
    const [foodStandard, setFoodStandard] = useState("");
    const [foodVegan, setFoodVegan] = useState("");
    const [foodOther, setFoodOther] = useState("");

    // ─── Стоимость ────────────────────────────────────────────────
    const [services, setServices] = useState([
        { title: "Машина", qty: "", price: "" },
        { title: "Питание", qty: "", price: "" },
        { title: "Проживание", qty: "", price: "" },
        { title: "Гид", qty: "", price: "" },
        { title: "Входные билеты", qty: "", price: "" },
    ]);
    const [items, setItems] = useState([]);
    const [peopleCount, setPeopleCount] = useState("");

    const [paymentType, setPaymentType] = useState("cash");
    const [paymentByDate, setPaymentByDate] = useState(false);
    const [paymentDate, setPaymentDate] = useState("");
    const [comment, setComment] = useState("");

    // ─── Проверка обязательных полей (*) — как в AddRequest ────────
    const [submitted, setSubmitted] = useState(false);
    const [saving, setSaving] = useState(false);

    // ─── Справочники ──────────────────────────────────────────────
    const [tours, setTours] = useState([]);
    const [company, setCompany] = useState([]);

    useEffect(() => {
        const getTours = async () => { const r = await axios.post(`${API_URL}/getTours`); setTours(r.data); };
        const getCompany = async () => { const r = await axios.post(`${API_URL}/getCompany`); setCompany(r.data); };
        getTours(); getCompany();
    }, [API_URL]);

    // ─── Загрузка заявки + проверка прав на сервере ────────────────
    useEffect(() => {
        const fetchForEdit = async () => {
            try {
                const r = await axios.post(`${API_URL}/getTourForEdit`, {
                    id,
                    requestedBy: user?.fullname,
                    requestedRole: user?.role,
                });
                setOrder(r.data.data);
                setType(r.data.type);
            } catch (err) {
                if (err?.response?.status === 403) setAccessDenied(true);
                else if (err?.response?.status === 404) setNotFound(true);
                else console.error("Ошибка загрузки заявки:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchForEdit();
    }, [API_URL, id, user]);

    const optionsCompany = company.map((i) => ({ value: i.name, label: i.name }));
    const optionsTours = tours.map((i) => ({ value: i.name, label: i.name }));
    const optionsGuide = [
        { value: true, label: "Да" },
        { value: false, label: "Нет" },
    ];
    const optionsNeedsYurt = [
        { value: true, label: "Да" },
        { value: false, label: "Нет" },
    ];

    const optionsGuideLang = [
        { value: "eng", label: "Английский" },
        { value: "rus", label: "Русский" },
        { value: "uz", label: "Узбекский" },
        { value: "itl", label: "Итальянский" },
        { value: "fra", label: "Французский" },
        { value: "deu", label: "Немецкий" },
        { value: "spa", label: "Испанский" },
        { value: "tur", label: "Турецкий" },
        { value: "chn", label: "Китайский" },
        { value: "jpn", label: "Японский" },
        { value: "kor", label: "Корейский" },
        { value: "ara", label: "Арабский" },
        { value: "hin", label: "Хинди" },
        { value: "per", label: "Персидский" },
        { value: "kaz", label: "Казахский" },
        { value: "taj", label: "Таджикский" },
    ];
    const optionsTyperequest = [
        { value: "individual", label: "Индивидуальный" },
        { value: "sharetour", label: "Совместный" },
        { value: "partners", label: "Партнеры" },
    ];

    // ─── Наполнение формы данными заявки (один раз) ────────────────
    useEffect(() => {
        if (!order || !type || hydrated) return;

        setTyperequest(optionsTyperequest.find((t) => t.value === type) || null);

        const parsedGuests = safeJSON(order.guests, []);
        setGuests(parsedGuests.length ? parsedGuests : [{ name: "", contacts: "" }]);

        setDateStart(order.date_start ? String(order.date_start).slice(0, 10) : "");
        setDateEnd(order.date_end ? String(order.date_end).slice(0, 10) : "");
        setParticipantsCount(order.participants_count ?? "");
        setNeedsYurt(order.needs_yurt ? { value: true, label: "Да" } : { value: false, label: "Нет" });
        setYurtComment(order.yurt_comment ?? "");

        setDeparturePlace(order.departure_place ?? "");
        setDepartureTime(order.departure_time ? String(order.departure_time).slice(0, 5) : "");
        setArrivalPlace(order.arrival_place ?? "");
        setTransportType(order.transport_type ?? "");

        setGuid(optionsGuide.find((o) => o.value === Boolean(order.guidetype)) || { value: false, label: "Нет" });
        setGuidlang(optionsGuideLang.find((o) => o.value === order.guidelang) || null);

        setMuseum(order.museum ?? "");
        setExtraLocation(order.extra_location ?? "");

        const food = safeJSON(order.food, { standard: 0, vegan: 0, other: 0 });
        setFoodStandard(food.standard ? String(food.standard) : "");
        setFoodVegan(food.vegan ? String(food.vegan) : "");
        setFoodOther(food.other ? String(food.other) : "");

        const parsedServices = safeJSON(order.services, []);
        if (parsedServices.length) {
            setServices(parsedServices.map((s) => ({ title: s.title, qty: s.qty ?? "", price: s.price ?? "" })));
        }
        setItems(safeJSON(order.extra_items, []).map((i) => ({ title: i.title, qty: i.qty ?? "", price: i.price ?? "" })));
        setPeopleCount(order.people_count ?? "");
        setPaymentType(order.payment_type || "cash");
        setPaymentByDate(!!order.payment_by_date);
        setPaymentDate(order.payment_date ? String(order.payment_date).slice(0, 10) : "");
        setComment(order.comment ?? "");

        setTourOperator(order.tour_operator ?? "");
        setCustomerContacts(order.customer_contacts ?? "");
        setGroupNumber(order.group_number ?? "");

        setHydrated(true);
    }, [order, type, hydrated]);

    // ─── Подстановка значений в Select после загрузки справочников ─
    useEffect(() => {
        if (order?.company && company.length) {
            const match = optionsCompany.find((o) => o.value === order.company);
            if (match) setComp(match);
        }
    }, [order, company]);

    useEffect(() => {
        if (order?.tour && tours.length) {
            const match = optionsTours.find((o) => o.value === order.tour);
            if (match) setTour(match);
        }
    }, [order, tours]);

    // ─── Подсчёт итогов ───────────────────────────────────────────
    const servicesTotal = services.reduce((s, i) => s + Number(i.qty || 0) * Number(i.price || 0), 0);
    const extraTotal = items.reduce((s, i) => s + Number(i.qty || 0) * Number(i.price || 0), 0);
    const grandTotal = servicesTotal + extraTotal;

    const updateService = (index, field, value) => {
        const arr = [...services];
        arr[index][field] = value;
        setServices(arr);
    };

    const addItem = () => {
        setItems([...items, { title: "", qty: "", price: "" }]);
    };

    const updateItem = (index, field, value) => {
        const arr = [...items];
        arr[index][field] = value;
        setItems(arr);
    };

    const selectStyles = (dark = false) => ({
        control: (base, state) => ({
            ...base,
            backgroundColor: dark ? "#1d2547" : "#fff",
            width: dark ? "300px" : "100%",
            border: state.isFocused ? "2px solid #4f7cff" : "2px solid gray",
            borderRadius: "10px",
            padding: "5px",
            boxShadow: "none",
            cursor: "pointer",
            "&:hover": { border: "2px solid #4f7cff" },
        }),
        singleValue: (base) => ({ ...base, color: dark ? "#fff" : "#1d2547" }),
        placeholder: (base) => ({ ...base, color: "#aaa" }),
        menu: (base) => ({ ...base, backgroundColor: "#fff", borderRadius: "10px", padding: "10px", overflow: "hidden" }),
        option: (base, state) => ({
            ...base,
            borderRadius: "10px",
            backgroundColor: state.isSelected || state.isFocused ? "#1d2547" : "#fff",
            color: state.isSelected || state.isFocused ? "#fff" : "#1d2547",
            cursor: "pointer",
            transition: "0.15s",
        }),
        input: (base) => ({ ...base, color: dark ? "#fff" : "#1d2547" }),
    });

    // Возвращает { ключ_поля: "текст ошибки" } — пустой объект, если всё заполнено
    const validate = () => {
        const e = {};
        const empty = (v) => !String(v ?? "").trim();

        if (type === "partners") {
            if (!comp) e.company = "Выберите заказчика";
            if (empty(tourOperator)) e.tourOperator = "Укажите тур оператора";
            if (empty(customerContacts)) e.customerContacts = "Укажите контакты заказчика";
        }

        // Первый гость обязателен; остальные места (Share Tour) — если начали заполнять
        guests.forEach((g, i) => {
            const touched = !empty(g.name) || !empty(g.contacts);
            if (i === 0 || touched) {
                if (empty(g.name)) e[`guest-${i}-name`] = `Укажите имя гостя${guests.length > 1 ? ` ${i + 1}` : ""}`;
                if (empty(g.contacts)) e[`guest-${i}-contacts`] = `Укажите контакты гостя${guests.length > 1 ? ` ${i + 1}` : ""}`;
            }
        });

        if (!tour) e.tour = "Выберите программу тура";
        if (!dateStart) e.dateStart = "Укажите дату начала";
        if (!dateEnd) e.dateEnd = "Укажите дату окончания";
        else if (dateStart && dateEnd < dateStart) e.dateEnd = "Дата окончания раньше даты начала";
        if (!(Number(participantsCount) > 0)) e.participants = "Укажите количество участников";

        if (!transportType) e.transport = "Выберите тип транспорта";
        if (!guid) e.guide = "Укажите, нужен ли гид";

        if (!(grandTotal > 0)) e.services = "Заполните стоимость услуг — итог не может быть $0";
        items.forEach((it, i) => {
            const hasSum = (Number(it.qty) || 0) * (Number(it.price) || 0) > 0;
            if (hasSum && empty(it.title)) e[`item-${i}`] = `Укажите название доп. статьи ${i + 1}`;
        });

        if (paymentType === "cash" && paymentByDate && !paymentDate) e.paymentDate = "Укажите дату оплаты";
        return e;
    };

    const errors = submitted ? validate() : {};
    const errCls = (key) => (errors[key] ? " addrequest-field-error" : "");
    const errText = (key) => (errors[key] ? <small className="addrequest-error-text">{errors[key]}</small> : null);

    // ─── Сохранение изменений ───────────────────────────────────────
    const handleUpdate = async () => {
        if (saving) return;
        setSubmitted(true);
        const found = validate();
        const keys = Object.keys(found);
        if (keys.length) {
            toast.error(keys.length === 1 ? found[keys[0]] : `${found[keys[0]]} (и ещё ${keys.length - 1})`);
            setTimeout(() => {
                document.querySelector(".addrequest-field-error")?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 50);
            return;
        }

        // «Оплата по дате» бывает только у налички
        const byDate = paymentType === "cash" && paymentByDate;

        const payload = {
            type,
            orderNumber: order.order_number,
            requestedBy: user?.fullname,
            requestedRole: user?.role,

            company: comp?.value || null,
            tourOperator,
            customerContacts,
            groupNumber,

            guests: guests.map((g) =>
                isShare
                    ? {
                        name: g.name,
                        contacts: g.contacts,
                        departurePlace: g.departurePlace || "",
                        departureTime: g.departureTime || "",
                        arrivalPlace: g.arrivalPlace || "",
                    }
                    : { name: g.name, contacts: g.contacts }
            ),

            tour: tour?.value || null,
            dateStart,
            dateEnd,
            participantsCount: Number(participantsCount) || 0,
            needsYurt: needsYurt.value,
            yurtComment: needsYurt.value ? yurtComment : null,
            departurePlace: isShare ? null : departurePlace,
            departureTime: isShare ? null : departureTime,
            arrivalPlace: isShare ? null : arrivalPlace,
            transportType,
            guideType: guid ? guid.value : null,
            guideLang: guid?.value === true ? guidlang?.value || null : null, // гид «Нет» — язык не нужен
            museum,
            extraLocation,

            food: {
                standard: Number(foodStandard) || 0,
                vegan: Number(foodVegan) || 0,
                other: Number(foodOther) || 0,
            },

            services: services.map((s) => ({
                title: s.title,
                qty: Number(s.qty) || 0,
                price: Number(s.price) || 0,
                total: (Number(s.qty) || 0) * (Number(s.price) || 0),
            })),
            extraItems: items.map((i) => ({
                title: i.title,
                qty: Number(i.qty) || 0,
                price: Number(i.price) || 0,
                total: (Number(i.qty) || 0) * (Number(i.price) || 0),
            })),
            peopleCount: Number(peopleCount) || 0,
            grandTotal,
            paymentType,
            paymentByDate: byDate,
            paymentDate: byDate ? paymentDate : null,

            comment, // раньше не отправлялся — комментарий терялся
        };

        setSaving(true);
        try {
            await axios.post(`${API_URL}/updateRequest`, payload);
            toast.success("Изменения сохранены");
            navigate(`/tourdetails/${order.order_number}`);
        } catch (err) {
            console.error("Ошибка при сохранении:", err);
            toast.error("Не удалось сохранить изменения");
        } finally {
            setSaving(false);
        }
    };

    // ─── Состояния загрузки / отказа в доступе ─────────────────────
    if (loading) {
        return <div style={{ padding: 40, textAlign: "center", fontSize: 18, color: "#1d2547" }}>Загрузка заявки...</div>;
    }
    if (notFound) {
        return <div style={{ padding: 40, textAlign: "center", fontSize: 18, color: "#1d2547" }}>Заявка не найдена</div>;
    }
    if (accessDenied) {
        return (
            <div style={{ padding: 40, textAlign: "center", fontSize: 18, color: "#1d2547" }}>
                Нет прав на редактирование этой заявки 🚫
            </div>
        );
    }

    // ─── Блоки формы (идентичны AddRequest) ────────────────────────
    const renderCustomerBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-regular fa-user"></i>
                <h2>Заказчик</h2>
            </div>
            <div className="addrequest-input-flex">
                <div className={`addrequest-input-box${errCls("company")}`}>
                    <label>Имя Заказчика *</label>
                    <label style={{ width: "100%" }}>
                        <Select options={optionsCompany} isClearable value={comp} onChange={setComp} placeholder="Выберите компанию" styles={selectStyles()} />
                    </label>
                    {errText("company")}
                </div>
                <div className={`addrequest-input-box${errCls("tourOperator")}`}>
                    <label>Тур оператор *</label>
                    <input type="text" value={tourOperator} onChange={(e) => setTourOperator(e.target.value)} />
                    {errText("tourOperator")}
                </div>
                <div className={`addrequest-input-box${errCls("customerContacts")}`}>
                    <label>Контакты (Почта / Телефон) *</label>
                    <input type="text" value={customerContacts} onChange={(e) => setCustomerContacts(e.target.value)} />
                    {errText("customerContacts")}
                </div>
                <div className="addrequest-input-box">
                    <label>Номер группы</label>
                    <input type="text" value={groupNumber} onChange={(e) => setGroupNumber(e.target.value)} />
                </div>
            </div>
        </div>
    );

    const renderGuestBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-regular fa-address-card"></i>
                <h2>Контактная информация гостя</h2>
            </div>
            {guests.map((guest, index) => (
                <div className="addrequest-input-flex" key={index}>
                    {guests.length > 1 && (
                        <div style={{ width: "100%", padding: "4px 0 2px" }}>
                            <label style={{ fontWeight: 600, color: "#1d2547" }}>Гость {index + 1}</label>
                        </div>
                    )}
                    <div className={`addrequest-input-box${errCls(`guest-${index}-name`)}`}>
                        <label>Имя гостя {index === 0 ? "*" : ""}</label>
                        <input type="text" value={guest.name} onChange={(e) => updateGuest(index, "name", e.target.value)} />
                        {errText(`guest-${index}-name`)}
                    </div>
                    <div className={`addrequest-input-box${errCls(`guest-${index}-contacts`)}`}>
                        <label>Контакты (Почта / Телефон) {index === 0 ? "*" : ""}</label>
                        <input type="text" value={guest.contacts} onChange={(e) => updateGuest(index, "contacts", e.target.value)} />
                        {errText(`guest-${index}-contacts`)}
                    </div>
                    {isShare && (
                        <>
                            <div className="addrequest-input-box">
                                <label>Место выезда</label>
                                <input type="text" value={guest.departurePlace || ""} onChange={(e) => updateGuest(index, "departurePlace", e.target.value)} />
                            </div>
                            <div className="addrequest-input-box">
                                <label>Время выезда</label>
                                <input type="time" value={guest.departureTime || ""} onChange={(e) => updateGuest(index, "departureTime", e.target.value)} />
                            </div>
                            <div className="addrequest-input-box">
                                <label>Место высадки</label>
                                <input type="text" value={guest.arrivalPlace || ""} onChange={(e) => updateGuest(index, "arrivalPlace", e.target.value)} />
                            </div>
                        </>
                    )}
                </div>
            ))}
        </div>
    );

    const renderTourBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-location-dot"></i>
                <h2>Программа тура</h2>
            </div>
            <div className="addrequest-input-flex">
                <div className={`addrequest-input-box${errCls("tour")}`}>
                    <label>Программа *</label>
                    <label style={{ width: "100%" }}>
                        <Select options={optionsTours} isClearable value={tour} onChange={setTour} placeholder="Выберите тур" styles={selectStyles()} />
                    </label>
                    {errText("tour")}
                </div>
                <div className={`addrequest-input-box${errCls("dateStart")}`}>
                    <label>Дата начала *</label>
                    <input type="date" value={dateStart} onChange={(e) => setDateStart(e.target.value)} />
                    {errText("dateStart")}
                </div>
                <div className={`addrequest-input-box${errCls("dateEnd")}`}>
                    <label>Дата окончания *</label>
                    <input type="date" value={dateEnd} min={dateStart || undefined} onChange={(e) => setDateEnd(e.target.value)} />
                    {errText("dateEnd")}
                </div>
                <div className={`addrequest-input-box${errCls("participants")}`}>
                    <label>Количество участников *</label>
                    <input type="number" min="1" value={participantsCount} onChange={(e) => setParticipantsCount(e.target.value)} />
                    {errText("participants")}
                </div>
                <div className="addrequest-input-box">
                    <label>Размещение в юрте</label>
                    <label style={{ width: "100%" }}>
                        <Select
                            options={optionsNeedsYurt}
                            value={needsYurt}
                            onChange={setNeedsYurt}
                            placeholder="Нужна юрта?"
                            styles={selectStyles()}
                        />
                    </label>
                </div>

                {needsYurt.value && (
                    <div className="addrequest-input-box">
                        <label>Комментарий для юрты</label>
                        <input
                            type="text"
                            value={yurtComment}
                            onChange={(e) => setYurtComment(e.target.value)}
                        />
                    </div>
                )}
            </div>
        </div>
    );

    const renderLogisticsBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-train"></i>
                <h2>Логистика</h2>
            </div>
            {!isShare && (
                <div className="addrequest-input-flex">
                    <div className="addrequest-input-box">
                        <label>Место выезда</label>
                        <input type="text" value={departurePlace} onChange={(e) => setDeparturePlace(e.target.value)} />
                    </div>
                    <div className="addrequest-input-box">
                        <label>Время выезда</label>
                        <input type="time" value={departureTime} onChange={(e) => setDepartureTime(e.target.value)} />
                    </div>
                    <div className="addrequest-input-box">
                        <label>Место высадки</label>
                        <input type="text" value={arrivalPlace} onChange={(e) => setArrivalPlace(e.target.value)} />
                    </div>
                </div>
            )}

            <div className="addrequest-input-flex-select-car">
                <div className={`addrequest-input-box${errCls("transport")}`}>
                    <label>Тип транспорта *</label>
                    <span>
                        {[
                            { key: "4x4", icon: "fa-truck-monster", label: "4x4" },
                            { key: "sedan", icon: "fa-car", label: "Sedan" },
                            { key: "minivan", icon: "fa-van-shuttle", label: "Minivan" },
                            { key: "bus", icon: "fa-bus-side", label: "Bus" },
                            { key: "none", icon: "fa-solid fa-square-xmark", label: "Без машины" },
                        ].map((t) => (
                            <button
                                key={t.key}
                                type="button"
                                className={`addrequest-input-flex-select-car-btn${transportType === t.key ? " active" : ""}`}
                                onClick={() => setTransportType(t.key)}
                            >
                                <i className={`fa-solid ${t.icon}`}></i>
                                {t.label}
                            </button>
                        ))}
                    </span>
                    {errText("transport")}
                </div>
            </div>

            <div className="addrequest-input-flex">
                <div className={`addrequest-input-box${errCls("guide")}`}>
                    <label>Тур Гид *</label>
                    <label style={{ width: "100%" }}>
                        <Select
                            options={optionsGuide}
                            value={guid}
                            isClearable
                            onChange={setGuid}
                            placeholder="Выберите гид"
                            styles={selectStyles()}
                        />
                    </label>
                    {errText("guide")}
                </div>
                {guid?.value === true && (
                    <div className="addrequest-input-box">
                        <label>Язык гида</label>
                        <label style={{ width: "100%" }}>
                            <Select
                                options={optionsGuideLang}
                                value={guidlang}
                                isClearable
                                onChange={setGuidlang}
                                placeholder="Выберите язык"
                                styles={selectStyles()}
                            />
                        </label>
                    </div>
                )}

                <div className="addrequest-input-box">
                    <label>Музей</label>
                    <input type="text" value={museum} onChange={(e) => setMuseum(e.target.value)} />
                </div>
                <div className="addrequest-input-box">
                    <label>Доп. Локация</label>
                    <input type="text" value={extraLocation} onChange={(e) => setExtraLocation(e.target.value)} />
                </div>
            </div>

            <div className="addrequest-input-flex selectcafe">
                <div className="addrequest-input-box">
                    <label>Тип питания</label>
                    <table className="addrequest-input-flex-edit-eat">
                        <tbody>
                            <tr>
                                <th>ТИП</th>
                                <th><i className="fa-solid fa-utensils"></i> Стандарт</th>
                                <th><i className="fa-solid fa-carrot"></i> Веган</th>
                                <th><i className="fa-brands fa-creative-commons-nd"></i> Другое</th>
                            </tr>
                            <tr>
                                <th>Количество человек</th>
                                <td><input type="number" value={foodStandard} onChange={(e) => setFoodStandard(e.target.value)} /></td>
                                <td><input type="number" value={foodVegan} onChange={(e) => setFoodVegan(e.target.value)} /></td>
                                <td><input type="number" value={foodOther} onChange={(e) => setFoodOther(e.target.value)} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );

    const renderPriceBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-circle-dollar-to-slot"></i>
                <h2>Детали - Стоимость услуг *</h2>
            </div>
            <div className={`addrequest-input-flex-price-summary${errCls("services")}`}>
                <table>
                    <thead>
                        <tr>
                            <th>Статья</th>
                            <th>Кол-во</th>
                            <th>Цена / ед.</th>
                            <th>Итого</th>
                        </tr>
                    </thead>
                    <tbody>
                        {services.map((service, index) => (
                            <tr key={index}>
                                <td>{service.title}</td>
                                <td><input type="number" placeholder="0" value={service.qty} onChange={(e) => updateService(index, "qty", e.target.value)} /></td>
                                <td><input type="number" placeholder="$0" value={service.price} onChange={(e) => updateService(index, "price", e.target.value)} /></td>
                                <td className="total-price">${(Number(service.qty) || 0) * (Number(service.price) || 0)}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index} className={errCls(`item-${index}`).trim()}>
                                <td><input type="text" placeholder="Название" value={item.title} onChange={(e) => updateItem(index, "title", e.target.value)} /></td>
                                <td><input type="number" placeholder="0" value={item.qty} onChange={(e) => updateItem(index, "qty", e.target.value)} /></td>
                                <td><input type="number" placeholder="$0" value={item.price} onChange={(e) => updateItem(index, "price", e.target.value)} /></td>
                                <td>
                                    ${(Number(item.qty) || 0) * (Number(item.price) || 0)}
                                    <button className="deleteitems" type="button" onClick={() => setItems(items.filter((_, i) => i !== index))}>✕</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="4">
                                <button type="button" onClick={addItem} className="add-article-btn">+ Добавить статью ({items.length})</button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {errText("services")}
            {items.map((_, i) => <React.Fragment key={i}>{errText(`item-${i}`)}</React.Fragment>)}
            <div className="addrequest-box-info-panel-down">
                <h5>Итого с клиента</h5>
                <h4>${grandTotal.toLocaleString()}</h4>
            </div>
        </div>
    );

    const renderPaymentBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-credit-card"></i>
                <h2>Тип оплаты *</h2>
            </div>
            <div className="addrequest-input-flex-type-cash">
                {[
                    { key: "cash", icon: "fa-money-bill", label: "Наличка" },
                    { key: "transfer", icon: "fa-building-columns", label: "Перечисление" },
                ].map((p) => (
                    <button key={p.key} type="button" className={paymentType === p.key ? "active" : ""} onClick={() => setPaymentType(p.key)}>
                        <i className={`fa-solid ${p.icon}`}></i>
                        {p.label}
                    </button>
                ))}
            </div>

            {paymentType === "cash" && (
                <div className="addrequest-input-flex">
                    <div className="addrequest-input-box">
                        <label style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer" }}>
                            <input
                                className="checkbox"
                                type="checkbox"
                                checked={paymentByDate}
                                onChange={(e) => setPaymentByDate(e.target.checked)}
                            />
                            Оплата по дате
                        </label>
                    </div>

                    {paymentByDate && (
                        <div className={`addrequest-input-box${errCls("paymentDate")}`}>
                            <label>Дата оплаты *</label>
                            <input type="date" value={paymentDate} onChange={(e) => setPaymentDate(e.target.value)} />
                            {errText("paymentDate")}
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    const renderCommentBlock = () => (
        <div className="addrequest-inputstyle">
            <div className="addrequest-box-info-panel">
                <i className="fa-solid fa-comment-dots"></i>
                <h2>Дополнительные комментарии</h2>
            </div>
            <div className="addrequest-input-flex">
                <div className="addrequest-input-box">
                    <textarea placeholder="Особые пожелания, заметки, детали по питанию или трансферу." value={comment} onChange={(e) => setComment(e.target.value)} />
                </div>
            </div>
        </div>
    );

    return (
        <div className="addrequest">
            <div className="addrequest-flex">
                <div className="addrequest-box1">
                    <div className="addrequest-box1-info">Заказ №{order?.order_number ?? "…"}</div>
                    <div className="addrequest-box1-type-tour">
                        <Select
                            options={optionsTyperequest}
                            value={typerequest}
                            isDisabled
                            placeholder="Тип заявки"
                            styles={selectStyles(true)}
                        />
                    </div>
                    <div className="addrequest-box1-btn">
                        <button type="button" onClick={() => navigate(-1)}>Отмена</button>
                        <button type="button" onClick={handleUpdate} disabled={saving}>{saving ? "Сохраняем…" : "Сохранить"}</button>
                    </div>
                </div>

                {typerequest?.value === "partners" && renderCustomerBlock()}
                {renderGuestBlock()}
                {renderTourBlock()}
                {renderLogisticsBlock()}
                {renderPriceBlock()}
                {renderPaymentBlock()}
                {renderCommentBlock()}
            </div>
        </div>
    );
};

export default EditTour;